<template>
  <div>
    <page-header :actions="actions" :page="page" />

    <board class="mb-4" :details="board" />

    <div
      v-for="(appointment, idx) in appointments"
      :key="appointment.appointmentId"
      class="container-fluid p-3 bg-secondary-11 mt-4"
    >
      <div class="row">
        <div class="col-sm d-flex">
          <div class="mr-2">
            <em
              class="fas fa-calendar-alt color-primary-2 mt-2 rounded-circle shadow bg-white p-2"
            />
          </div>
          <div>
            <span class="data-name">Número de Cita:</span>
            <p class="data">{{ appointment.appointmentId }}</p>
          </div>
        </div>
        <div class="col-sm">
          <span class="data-name">Fecha:</span>
          <p class="data">{{ appointment.appointmentDate }}</p>
        </div>
        <div class="col-sm">
          <span class="data-name">Horario:</span>
          <p class="data">{{ appointment.appointmentTime }}</p>
        </div>
        <div
          v-if="appointment.specialistsAvailable.length === 0"
          class="col-sm"
        >
          <span class="color-secondary-2 font-14">
            {{ appointment.specialistsNotAvailableMessage }}
          </span>
        </div>
        <div v-else class="col-md-3 col-sm-12">
          <validation-observer :ref="'specChangeValidator' + idx">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="appointments[idx].selectedSpecialist"
                class="w-100"
                custom-error-msg="Favor de seleccionar un especialista."
                :error="errors[0]"
                fieldkey="specialistId"
                fieldname="fullName"
                :options="appointment.specialistsAvailable"
                placeholder="Seleccione Especialista"
              />
            </validation-provider>
          </validation-observer>
        </div>
        <div
          v-if="appointment.specialistsAvailable.length > 0"
          class="col-sm h-100 d-flex justify-content-end"
        >
          <action-button
            i="fas fa-exchange-alt"
            text="Cambiar"
            variant="success"
            @click="changeSpecialist(idx, appointments[idx])"
          />
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-sm-2">
          <div class="ml-4">
            <span class="data-name">Tipo de Servicio:</span>
            <p class="data">{{ appointment.serviceName }}</p>
          </div>
        </div>
        <div class="col-sm-4">
          <span class="data-name">Disciplina:</span>
          <p class="data">{{ appointment.disciplineName }}</p>
        </div>
        <div class="col-sm-2">
          <span class="data-name">Localización:</span>
          <p class="data">{{ appointment.locationName }}</p>
        </div>
        <div class="col-sm">
          <span class="data-name">Estudiante:</span>
          <p class="data">{{ appointment.studentDescription }}</p>
        </div>
      </div>
    </div>

    <div
      v-for="(item, idx) in tapRequests"
      :key="idx"
      class="container-fluid p-3 bg-secondary-11 mt-4"
    >
      <div class="row">
        <div class="col-sm">
          <span class="data-name">Número de Consulta:</span>
          <p class="data">{{ item.tapNumber }}</p>
        </div>
        <div class="col-sm">
          <span class="data-name">Fecha de Comienzo:</span>
          <p class="data">{{ item.startDate | date }}</p>
        </div>
        <div class="col-sm">
          <span class="data-name">Maestro:</span>
          <p class="data">{{ item.teacher }}</p>
        </div>
        <div class="col-sm">
          <span class="data-name">Asistente:</span>
          <p class="data">{{ item.specialist }}</p>
        </div>
      </div>
    </div>

    <div
      v-for="(item, idx) in referrals"
      :key="idx"
      class="container-fluid p-3 bg-secondary-11 mt-4"
    >
      <div class="row">
        <div class="col-sm">
          <span class="data-name">Número de Referido:</span>
          <p class="data">{{ item.referralNumber }}</p>
        </div>
        <div class="col-sm">
          <span class="data-name">Fecha de Inicio de Servicio:</span>
          <p class="data">{{ item.startDate | date }}</p>
        </div>
        <div class="col-sm">
          <span class="data-name">Especialista de Admisión:</span>
          <p class="data">{{ item.admissionSpecialist }}</p>
        </div>
        <div class="col-sm">
          <span class="data-name">Especialista de Servicio:</span>
          <p class="data">{{ item.serviceSpecialist }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from '@/components/common/form/CustomDropDown';
import storeMixin from '@/shared/mixins/storeGenerator';
import alert from '@/mixins/alert.mixin';
import {
  getSpecialist as _getSpecialist,
  getAppointmentsCoordinated as _getAppointmentsCoordinated,
  changeAppointmentSpecialist as _changeAppointmentSpecialist,
  getTeacherTapRequest as _getTeacherTapRequest,
  getReferralForTherapists as _getReferralForTherapists,
} from '@/modules/provider/api.js';

import academicYears from '@/modules/common/academicyear.api';
import appointmentStatusEnum from '@/modules/shared/constants/appointmentStatus';
import { mapGetters } from 'vuex';
import { name as userStoreName } from '@/modules/user/store';
import specialtyTypes from '@/utils/constants/addSpecialistSpecialtyTypes';

export default {
  name: '',
  components: {
    CustomDropDown,
  },
  mixins: [storeMixin, alert],
  data() {
    return {
      appointments: [],
      specialistData: {},
      academicyear: {},
      tapRequests: [],
      referrals: [],
    };
  },
  computed: {
    actions() {
      return [
        {
          component: 'ActionButton',
          text: 'Regresar',
          variant: 'outline-success',
          icon: 'fas fa-arrow-circle-left',
          click: () => {
            this.$router.back();
          },
          visible: this.isSpecialistActive,
        },
      ];
    },
    board() {
      return [
        [
          {
            label: 'Año Fiscal:',
            icon: 'fas fa-calendar-edit ',
            data: this.academicyear?.name,
          },
          {
            label: 'Compañía:',
            icon: 'fas fa-address-book',
            data: this.mainCompany.name,
          },
          {
            label: 'Especialista:',
            icon: 'fas fa-address-book',
            data: (this.specialistData || {}).fullName,
          },
          {
            label: 'Número Seguro Social:',
            icon: 'fas fa-ballot-check',
            data: (this.specialistData || {}).socialSecurityNumber,
          },
        ],
      ];
    },
    page() {
      return {
        title: this.$route.meta.title || 'Cambio de Especialista',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Especialistas', 'Cambio de especialista'],
      };
    },
    specialistId() {
      return this.$route.params.specialistId;
    },
    ...mapGetters(userStoreName, ['mainCompany']),
  },
  async mounted() {
    await this.loadData();
    await this.getAppointments();
  },
  methods: {
    async changeSpecialist(idx, appointment) {
      const isValid = await this.$refs[
        'specChangeValidator' + idx
      ][0].validate();

      if (isValid) {
        await _changeAppointmentSpecialist(
          appointment.appointmentId,
          appointment.selectedSpecialist.specialistLocationId
        ).then(async () => {
          this.ShowToast(
            'Proceso Exitoso',
            'Cambio efectuado exitosamente',
            'success'
          );

          await this.loadData();
          await this.getAppointments();
        });
      }
    },
    getAppointmentStatus(id) {
      let status = Object.values(appointmentStatusEnum).find(
        (item) => item.id == id
      );
      return {
        color: status ? `color-${status.color}` : '',
        label: (status || {}).label,
      };
    },
    async getAppointments() {
      const model = {
        specialistId: this.$route.params.specialistId,
        companyId: this.$route.params.companyId,
      };
      const { data } = await _getAppointmentsCoordinated(model);
      (data || []).forEach((item) => {
        let metadata = this.getAppointmentStatus(item.appointmentStatusId);
        item.color = metadata.color;
        //TODO: which property maps the status name in the api?
        item.statusName = metadata.label;
      });
      this.appointments = data;
      if (
        this.specialistData.licenses &&
        this.specialistData.licenses.some(
          (x) =>
            x.specialtyTypeId == specialtyTypes.AsistenteServicio ||
            x.specialtyTypeId == specialtyTypes.Maestro
        )
      ) {
        const tapRequests = await _getTeacherTapRequest(model);
        this.tapRequests = tapRequests.data;
      }

      if (
        this.specialistData.licenses &&
        this.specialistData.licenses.some(
          (x) =>
            x.specialtyTypeId !== specialtyTypes.AsistenteServicio &&
            x.specialtyTypeId !== specialtyTypes.Maestro
        )
      ) {
        const referrals = await _getReferralForTherapists(model);
        this.referrals = referrals.data;
      }
    },
    async loadData() {
      const { data } = await _getSpecialist(this.specialistId).catch(() =>
        self.ShowToast('Error', 'Ocurrió un error cargando los datos', 'error')
      );
      this.specialistData = data;

      const academicYear = await academicYears
        .getCurrentAcademicYear()
        .catch(() =>
          self.ShowToast(
            'Error',
            'Ocurrió un error cargando los datos',
            'error'
          )
        );

      this.academicyear = academicYear;
    },
  },
};
</script>
